window.addEventListener('load', () => {
    var swiper = new Swiper('.product-swiper-container', {
        slidesPerView: 1,
        spaceBetween: 100,
        loop: false,
        autoplay: false,
        pagination: {
        el: '.product-thumbnails-pagination',
        clickable: true,
        renderBullet: function(index, className) {
            return '<div class="' + className + ' product-thumbnails__item" data-index="' + index + '">'
                    + document.querySelectorAll('.product-thumbnails__item img')[index].outerHTML
                    + '</div>';
        },
        },
        navigation: {
        nextEl: '.pdp-carousel-arrow-next',
        prevEl: '.pdp-carousel-arrow-prev',
        },
    });

    document.querySelectorAll('.product-thumbnails__item').forEach((element, index) => {
        element.addEventListener('click', () => {
        swiper.slideToLoop(index); 
        });
    });

    swiper.on('slideChange', () => {
        let currentIndex = swiper.realIndex;
        document.querySelectorAll('.product-thumbnails__item').forEach((el, i) => {
        el.classList.toggle('active', i === currentIndex);
        });
        const activeThumb = document.querySelectorAll('.product-thumbnails__item')[currentIndex];
        if (activeThumb) {
            activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    });
    
    const firstThumb = document.querySelector('.product-thumbnails__item');
    if (firstThumb) firstThumb.classList.add('active');
    firstThumb?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
    const thumbsInner = document.querySelector('.pdp-carousel-thumbnails-inner');
    const thumbPrev = document.querySelector('.pdp-carousel-arrow-prev');
    const thumbNext = document.querySelector('.pdp-carousel-arrow-next');
    if (thumbsInner && (thumbPrev || thumbNext)) {
        const getThumbWidth = () => {
            const item = document.querySelector('.product-thumbnails__item');
            if (!item) return Math.max(thumbsInner.clientWidth * 0.25, 100);
            const style = window.getComputedStyle(item);
            const marginLeft = parseFloat(style.marginLeft) || 0;
            const marginRight = parseFloat(style.marginRight) || 0;
            return Math.ceil(item.offsetWidth + marginLeft + marginRight);
        };
        thumbNext?.addEventListener('click', (e) => {
            e.preventDefault();
            const step = getThumbWidth();
            thumbsInner.scrollBy({ left: step, behavior: 'smooth' });
        });
        thumbPrev?.addEventListener('click', (e) => {
            e.preventDefault();
            const step = getThumbWidth();
            thumbsInner.scrollBy({ left: -step, behavior: 'smooth' });
        });
    }
})  